import Grid from "@mui/material/Grid";
import ModelAutoComplete from "../../actprep-ui/components/ModelAutoComplete";

export default function LessonItemExtraFields({ formData, setFormData }) {
  return (
    <>
      <Grid size={12}>
        <ModelAutoComplete
          required
          modelName={"Lesson"}
          label={"Lesson"}
          variant="standard"
          value={formData.item_metadata?.lesson || null}
          setValue={(newLesson) =>
            setFormData((formData) => {
              formData.item_metadata.lesson = newLesson;
              return { ...formData };
            })
          }
        />
      </Grid>
    </>
  );
}
